import React from 'react';
import ReactDOM from 'react-dom/client';
import '../../shared/styles/common.css';
import '../../shared/components/Header/Header.css';
import '../../shared/components/Footer/Footer.css';
import './index.css';
import App from './App';

class PortalErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { error: Error | null }
> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: '2rem', fontFamily: 'system-ui', maxWidth: '600px' }}>
          <h2 style={{ color: '#b91c1c' }}>Portal failed to load</h2>
          <pre style={{ overflow: 'auto', background: '#fef2f2', padding: '1rem', fontSize: '12px' }}>
            {this.state.error.message}
          </pre>
          <p>Check the browser console (F12) for more details.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

const root = ReactDOM.createRoot(rootEl);
root.render(
  <React.StrictMode>
    <PortalErrorBoundary>
      <App />
    </PortalErrorBoundary>
  </React.StrictMode>
);

